"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.black = void 0;
var _styledComponents = require("styled-components");
const black = exports.black = (0, _styledComponents.css)`
 --app-primary-text-color: #FFF;
`;
const white = exports.white = (0, _styledComponents.css)`
 --app-primary-text-color: #000;
`;